import { useQuery } from "@tanstack/react-query";
import { getPageBySlug } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook لجلب صفحة محتوى حسب الـ slug
 * @param {string} slug - Page slug
 */
export function useGetPageBySlug(slug) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["page", i18next.language, slug],
        queryFn: () => getPageBySlug(slug),
        retry: false,
        enabled: !!slug, // Only run when slug is provided
    });

    const page = data?.data?.data || null;

    return { isLoading, error, page, refetch };
}
